import { Routes } from "../../constants/Routes";
import { CreateUserDto } from "../../models/CreateUserDto";
import BaseController from "../sharedControllers/BaseController";
import { IsUserInternal } from "../../services/AuthService";
import JSONModel from "sap/ui/model/json/JSONModel";

/**
 * @namespace akademika.akamont.pages.userAdd
 */

export default class UserAdd extends BaseController {
  route = Routes.USER_ADD;
  parentRoute = Routes.USER_LIST;

  getOptionsUri = "api/User/GetUserOptions";

  public async onRouteMatched() {
    await this.fetchModel(this.getOptionsUri, "options");
    this.setModel(new JSONModel({ value: IsUserInternal() }), "isUserInternal");
  }

  public async onAddUser() {
    const requestData = this.getModelData<CreateUserDto>();

    await this.post("api/User/CreateUser", {
      body: requestData,
    });

    this.navTo(Routes.USER_LIST);
  }
}
